import { designTokens as dt, styled, Typography } from '@project44/manifest-ds';

import { scopedT } from '../../utils/functions/scopedT';
import ErrorIcon from './ErrorIcon';

const t = scopedT();

const Container = styled('div', {
  alignItems: 'flex-start',
  backgroundColor: `${dt.colorPaletteGrey200}`,
  display: 'flex',
  justifyContent: 'center',
  pt: 80,
  width: '100%',
  height: '100%',
});

const Content = styled('div', {
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});

const Title = styled(Typography, {
  fontWeight: 500,
  mb: 8,
  mt: 16,
});

const Message = styled(Typography, {
  mt: 0,
});

interface ErrorPage {
  message?: string;
  title?: string;
}

export const ErrorPage = (props: ErrorPage) => {
  const { title = t('errorPage.title'), message = t('errorPage.description') } =
    props;

  return (
    <Container data-testid="error-page">
      <Content>
        <ErrorIcon />
        <Title variant="title">{title}</Title>
        <Message variant="subtext">{message}</Message>
      </Content>
    </Container>
  );
};

export default ErrorPage;
